<template>
  <div class="account_set_wrap" v-loading="loading">
    <div class="account_set_header">
      <h2>安全设置</h2>
    </div>
    <div class="account_set_content">
      <el-form :model="securitySetForm" :rules="securitySetFormrules" ref="securitySetForm" label-width="120px" class="person_info_form">
        <el-form-item label="手机号：" prop="phoneNum">
          <el-input v-model.trim="securitySetForm.phoneNum" maxLength="11" :disabled="isdisabled"></el-input>
          <el-button v-if="!isUntyingOrReplace" class="change_binding_btn" @click="changeBinding(2)">更改</el-button>
          <el-button v-if="!isUntyingOrReplace" class="cancel_binding_btn" @click="changeBinding(3)">解除</el-button>
        </el-form-item>
        <el-form-item label="验证码：" prop="phoneCode" v-if="isUntyingOrReplace" class="phoneCode">
          <el-input v-model.trim="securitySetForm.phoneCode" maxLength="10"></el-input>
          <el-button
            v-if="isUntyingOrReplace"
            class="verificationCode_btn"
            @click="sendMessage('securitySetForm',securitySetForm.phoneNum)"
            :disabled="isSendMsg">{{isSendMsg?count+'s重新发送':'获取验证码'}}</el-button>
        </el-form-item>
        <el-button class="submit" v-if="isUntyingOrReplace" @click="submitForm('securitySetForm')">保 存</el-button>
        <el-button class="cancel" v-if="isUntyingOrReplace" @click="cancelChange()">取消</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import * as api from '../../../../api/userApi'
export default {
  inject: ['reload'],
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value) {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }else if(value==''){
        return callback(new Error('手机号码不能为空'));
      }else{
        callback();
      }
    };
    return {
      loading: true,
      securitySetForm: {
        phoneNum:'',
        phoneCode:''
      },
      securitySetFormrules:{
        phoneNum: [{ validator: checkPhone, trigger: 'blur'}],
        phoneCode: [{required: true, message: '请输入验证码', trigger: 'blur'}],
      },
      loginflag:true,
      count: 60,
      isSendMsg: false,
      OriginalPhoneNumber:'',
      isUntyingOrReplace: false,
      isdisabled: true,
      bindingStatus: '',
      height: window.innerHeight
    };
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo(){
      api.getUserInfo().then(rs=>{
        if(rs.code==0){
          let reg=/^(.{3}).*(.{4})$/;
          this.securitySetForm = {
            // phoneNum: rs.data.mobile,
            phoneNum: rs.data.mobile.replace(reg,'$1****$2'),
            phoneCode: ''
          }
          this.OriginalPhoneNumber = rs.data.mobile
          this.loading = false
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    submitForm(formName) {
      let that = this
      if(that.loginflag){
        that.loginflag = false
        that.$refs[formName].validate((valid) => {
          if (valid) {
            let obj = {
              mobile: that.securitySetForm.phoneNum,
              code: that.securitySetForm.phoneCode,
              statusBound: that.bindingStatus
            }
            api.updateUserInfoSafe(obj).then(rs=>{
              if(rs.code==0){
                if(obj.statusBound!=3){
                  this.$messageSuccess(rs.msg)
                  this.reload()
                }else{
                  this.$messageSuccess('手机绑定已解除，请重新登录')
                  api.updatePasswordLogout(localStorage.getItem('Authorization')).then(rs=>{
                    sessionStorage.clear()
                    localStorage.clear()
                    this.$router.push('/home')
                  })
                }
              }else{
                this.$messageError(rs.msg)
              }
            }).catch(err=>{
              console.log(err)
            })
            that.loginflag = true
          } else {
            console.log('error submit!!');
            that.loginflag = true
            return false;
          }
        });
      }
    },
    sendMessage(formName,phone){
      if(this.bindingStatus==2){
        if(this.OriginalPhoneNumber==phone){
          this.$messageWarning('您还没有修改手机号码。')
          return
        }
      }
      this.$refs[formName].validateField("phoneNum",(phoneError)=>{
        if(!phoneError){
          this.goGrdoupRecor()
          this.isSendMsg = true
          api.sendMessage(qs.stringify({phone:phone})).then(rs=>{
            if (String(rs.code) === '0'){
              this.$messageSuccess('验证码已发送！')
            }else {
              this.$messageError(rs.msg || '未知错误')
            }
          }).catch(err=>{
            console.log(err)
          })
        }
      });
    },
    goGrdoupRecor(){
      const TIME_COUNT = 60;
      if(!this.timer){
        this.count = TIME_COUNT;
        this.timer = setInterval(()=>{
          if(this.count > 1 && this.count <= TIME_COUNT){
            this.count--;
          }else{
            clearInterval(this.timer);
            this.timer = null;
            //倒计时结束
            this.isSendMsg = false
          }
        },1000)
      }
    },
    changeBinding(status){
      this.isUntyingOrReplace = true
      this.bindingStatus = status
      if(status==2){
        this.isdisabled = false
				this.securitySetForm.phoneNum = this.OriginalPhoneNumber
      }else{
        this.isdisabled = true
        this.securitySetForm.phoneNum = this.OriginalPhoneNumber
      }
    },
    cancelChange(){
			let reg=/^(.{3}).*(.{4})$/;
      this.isUntyingOrReplace = false
      this.isdisabled = true
      this.$refs['securitySetForm'].resetFields();
      this.securitySetForm.phoneNum = this.OriginalPhoneNumber.replace(reg,'$1****$2')
    }
  }
}
</script>
<style lang="scss" scoped>
.account_set_wrap {
  /deep/ .account_set_content{
    border-top: 1px solid #fff;
    .person_info_form{
      .el-form-item__content{
        .el-input.is-disabled .el-input__inner{
          color: #999999;
        }
        .verificationCode_btn{
          width: 94px;
          height: 40px;
          background: #1890FF;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          position: absolute;
          right: 0;
          top: 0;
          padding: 0;
          &:hover{
            opacity: 0.8;
          }
        }
        .verificationCode_btn.is-disabled{
          background: #F5F5F7;
          border-radius: 4px;
          color: #999;
          cursor: not-allowed;
          background-image: none;
          &:hover{
            opacity: 1;
          }
        }
        .change_binding_btn,.cancel_binding_btn{
          font-size: 14px;
          font-weight: 400;
          color: #1890FF;
          position: absolute;
          top: 15px;
          padding: 0;
          border: none;
        }
        .change_binding_btn{
          right: -50px;
        }
        .cancel_binding_btn{
          right: -100px;
          &::after{
            content: "";
            width: 1px;
            height: 14px;
            background: #D2D2D7;
            position: absolute;
            left: -11px;
            top: 0;
          }
        }
      }
      .phoneCode{
        .el-input{
          width: 265px;
        }
      }
      .cancel{
        width: 128px;
        height: 40px;
        border-radius: 6px;
        border: 1px solid #1890FF;
        font-size: 14px;
        font-weight: 400;
        color: #1890FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/securitySetting.vue